// import PreactImage from '@/components/snippets/image/image'
import { LogoUrl } from '../helpers/GlobalAssets'
import { useEffect } from 'preact/hooks'
import JsBarcode from 'jsbarcode'
import { formatMoney } from '@/components/libs/shopify'

export const AccountFitClubCard = ({ barcodeUrl, memberSince, barcode, total, showTotal = true }) => {
  useEffect(() => {
    if (!barcode) return
    setTimeout(() => {
      JsBarcode('#barcode', barcode, {
        width: 2,
        height: 30,
        displayValue: false,
        text: ''
      })
    }, 100)
  }, [barcode])

  const totalDisplay = formatMoney((total ?? 0) * 100)

  return (
    <div className={'rounded-2xl bg-secondary-yellow drop-shadow-md'}>
      <div className={'flex flex-col gap-4 p-4'}>
        <div data-role="header" className={'flex flex-col'}>
          <p className={'paragraph-lg font-bold'}>Fit Club</p>
          {!!memberSince && <p className={'paragraph-sm text-neutrals-secondary-grey'}>Member since {memberSince}</p>}
        </div>
        <div data-role="barcode" className={'flex flex-col gap-4'}>
          <div className={'h-12 w-full overflow-hidden rounded-2xl bg-primary-white'}>
            <img class={'m-auto h-full'} id="barcode" />
            {/* <PreactImage
              imageClass="fit object-bottom"
              className={'h-full w-full object-cover'}
              key={barcode}
              imageUrl={[barcodeUrl]}
            /> */}
          </div>
          <div className={'paragraph-sm text-center font-bold'}>{barcode}</div>
        </div>
        <div data-role="logo" className={'flex flex-row justify-between'}>
          <div className={'w-11/12'}>{showTotal ? totalDisplay : ''}</div>
          <div className={'h-full w-1/2'}>
            <div className={'flex h-full items-center justify-end'}>
              <img src={LogoUrl} className={'w-1/2` h-full object-contain'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
